import { render } from "./NavLinks.vue?vue&type=template&id=bb623404"
import script from "./NavLinks.vue?vue&type=script&lang=js"
export * from "./NavLinks.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"public/themes/default/resources/app/vue/components/AdvancedSearch/NavLinks.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "bb623404"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('bb623404', __exports__)) {
    api.reload('bb623404', __exports__)
  }
  
  module.hot.accept("./NavLinks.vue?vue&type=template&id=bb623404", () => {
    api.rerender('bb623404', render)
  })

}


export default __exports__